<template>
    <div class="component component__adress">
        {{ formattedAddress }}
    </div>
</template>

<script>
export default {
  name: 'component-address',
  props: {
    address: {
      type: [Array, Object],
      required: true
    }
  },
  computed: {
    formattedAddress: function () {
      if (this.address.type === 'automatic') {
        return this.address.formatted_address
      } else if (this.address.type === 'manual') {
        return `${this.address.address_1} ${this.address.address_2} ${this.address.city} ${this.address.postcode} ${this.address.county} ${this.address.country}`
      } else {
        return false
      }
    }
  }
}
</script>
